__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ir-external";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@afterpaytouch/core", "0.180.0", () => (Promise.all([__webpack_require__.e(812), __webpack_require__.e(36), __webpack_require__.e(354), __webpack_require__.e(637)]).then(() => (() => (__webpack_require__(1812))))));
			register("launchdarkly-react-client-sdk", "2.29.4", () => (Promise.all([__webpack_require__.e(525), __webpack_require__.e(36)]).then(() => (() => (__webpack_require__(4525))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(36)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.2.1", () => (Promise.all([__webpack_require__.e(18), __webpack_require__.e(36), __webpack_require__.e(364), __webpack_require__.e(160)]).then(() => (() => (__webpack_require__(3160))))));
			register("react-router", "6.2.1", () => (Promise.all([__webpack_require__.e(18), __webpack_require__.e(521), __webpack_require__.e(36)]).then(() => (() => (__webpack_require__(8521))))));
			register("react", "17.0.2", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};